import React from 'react';
type Variant = 'primary' | 'secondary' | 'ghost' | 'light' | 'outlineLight';
type Size = 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 font-display font-semibold tracking-[0.08em] rounded-[13px] transition-[background-color,color,border-color,transform,box-shadow] duration-200 ease-out active:scale-[0.985] disabled:opacity-60 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-teal text-white hover:bg-[#365e63] shadow-soft',
  secondary: 'bg-transparent text-teal border border-teal/35 hover:border-teal hover:bg-teal/[0.06]',
  ghost: 'bg-white text-ink border border-ink/10 hover:border-ink/25 shadow-soft',
  light: 'bg-white text-teal hover:bg-cream shadow-soft',
  outlineLight: 'bg-transparent text-white border border-white/45 hover:bg-white/10 hover:border-white'
};
const sizes: Record<Size, string> = {
  md: 'text-[11.5px] px-5 py-3',
  lg: 'text-[12.5px] px-7 py-4'
};
type CommonProps = {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  className?: string;
  children: React.ReactNode;
};
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth,
  className = '',
  children,
  ...rest
}: CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...rest} data-id="element-287" data-mp="oo3ohufeamf7">
      {children}
    </button>;
}
export function LinkButton({
  variant = 'primary',
  size = 'md',
  fullWidth,
  className = '',
  children,
  ...rest
}: CommonProps & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return <a className={`${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...rest} data-id="element-288" data-mp="1cfhlidohr66i">
      {children}
    </a>;
}